import "../../Styles/loginPage.scss";
import arrowIcon from "../../Assests/icons/Vector.png";
import { forgotPwd } from '../../redux/reducers/forgotPwdReducer';
import EmailIcon from "../../Assests/icons/email.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

export default function ResetPasswordSuccess({ email }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
 
  const handleBackButton = () => {
    navigate("/signin");
  };
  return (
    <>
      <div className="reset-password-success-container">
        <div className="reset-password-success-sub-container">
          <div className="email-icon-container">
            <div className="email-icon-sub-container">
              <img className="email-icon" src={EmailIcon} alt="Email" />
            </div>
          </div>
          <div className="loginDesc">
            <div className="loginHead">Check your email</div>
            <div className="loginSubDiv">
              We sent a reset password to <span>{email}</span>
            </div>
          </div>
          <div className="auth_container">
          <a href="mailto:">
            <button
              type="submit"
              //  disabled={loading}
              autoComplete="off"
              className="login_button hover-btn-animation"
            >
              {" "}
              OPEN EMAIL APP
            </button>
            </a>
          </div>
          <div className="resend-email">
            Didn't receive the email? <span onClick={() => dispatch(forgotPwd({ email, dispatch }))}>Click to resend</span>
          </div>
          <div className="backButtonContainer" onClick={handleBackButton}>
            <div className="backButton">
              <div>
                <img src={arrowIcon} alt="arrow" />
              </div>
              <div className="buttonText">Back To Login</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
